<template>
	<!-- 重設交易密碼 -->
	<div class="deal_index_box">
		<!-- 内容 -->
			<div class="deal_title">
				<div>個人資訊<span>》</span>交易密碼</div>
				<div class="deal_hr">
					<div class="cut_off"></div>
				</div>
			</div>
			<!-- 重設交易密碼 -->
			<div class="deal_content_box">
				<div class="deal_content_title">重設交易密碼</div>
				<!-- 交易密碼修改 -->
				<div class="deal_content div_hight_end" >
					<el-row>
						<el-col :span="16" :xs="24" class="list_tile_sed icon_phigt" >
							<i class="el-icon-warning colro-red"></i><span >簡訊驗證碼將發送到綁定的手機<span>(091******87)</span>,
							收到驗證碼後請填入下方欄位</span>
							<el-button type="warning" class="bottn_warning">點擊發送驗證碼</el-button>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8" >
							<div class="right_col">
								<span class="list_span">*</span>簡訊驗證碼：
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="code" ></el-input>
						</el-col>
						<el-col :span="6">
							<div class="right_col_left">沒有收到驗證碼？</div>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col"><span class="list_span">*</span>新的<span class="list_span">交易</span>密碼：</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="password" ></el-input>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col"><span class="list_span">*</span>重複<span class="list_span">交易</span>密碼：</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="re_password" ></el-input>
						</el-col>
						<el-col :span="6">
							<div class="list_span_end">重複密碼輸入錯誤</div>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end painde_top">
						<el-col :span="15" class="button_cetent">
							<el-button type="danger" plain class="bottom_onew">返回</el-button>
							<el-button type="danger" class="bottom_two">送出</el-button>
						</el-col>
					</el-row>
				</div>
				<!-- 修改成功 -->
				<div class="deal_content div_hight_dedt" v-if="paymentslue">
					<el-row>
						<el-col :span="6" :xs="8" class="list_tile_sed icon_phigt" >
							<i class="el-icon-warning colro-red"></i><span >設定完成</span>
						</el-col>
					</el-row>
	
				</div>
			</div>
			<!-- deal_index_box -->
	</div>



</template>

<script>
    import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			return {
				paymentslue: false,
                re_password:'',
                password:'',
                code:'',
				// return
			}
		},
		methods: {

		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}
    .deal_title {
    	display: flex;
    	justify-content: flex-start;
    	padding-bottom: 10px;
    }
    
    .deal_title span {
    	margin-left: 15px;
    	margin-right: 8px;
    }
    
    .deal_title .deal_hr {
    	flex: 1;
    	margin-left: 18px;
    }
    
    .deal_title .deal_hr .cut_off {
    	height: 3px;
    	background: black;
    	margin-top: 8px;
    }
	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 100px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}



	/* 个人资讯 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.div_hight {
		padding-top: 10px;
	}

	.btn_lits {
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 7px;
		padding-right: 7px;
		height: 16px;
		border-top-width: 1px;
		margin-top: 9px;
		margin-left: 10px;
		font-size: 11px;
		background: #e73262;
	}

	.div_hight_end {
		padding-top: 10px;
		
	}

	/* 重設交易密碼 */

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 25px 100px 25px 25px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;
	}

	.list_span {
		color: #e73262;
	}

	.right_col {
		float: right;
		padding-top: 7px;
		padding-right: 15px
	}

	.right_col_left {
		color: #4d80e7;
		padding-top: 7px;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-top: 7px;
		padding-left: 15px;
	}

	.paind_bottm {
		padding-bottom: 80px;
	}
	.p_cetent{
		padding-top: 20px;
	}
	.p_cetent span{
		color: #13ae22;
	}
	/deep/.input_high .el-input .el-input__inner{
		height: 27px;
		border: 1px solid #cccccc;
	}
	.paind_bottm_end{
		padding-bottom: 15px;
	}
	.button_cetent{
	    float: right;
		margin-top: 10px;	
		padding-bottom: 25px;
	}
	.button_cetent button{
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}
	.bottom_onew{
		color: #e73262;
		border-color: #e73262;
	}
	.bottom_two{
		background: #e73262;

	}
	.icon_phigt span{
		padding-left: 10px;
	}
	.div_hight_dedt{
		min-height: 330px;
		padding-top: 10px;
	}
	.bottn_warning{
		background-color:#ff771a ;
		border-color: #ff771a;
		font-size: 11px;
		padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 5px;
    padding-right: 5px;
		margin-bottom: 5px;
    margin-left: 10px;
	}
	.painde_top{
		padding-top: 100px;
	}
</style>

